import { DataManagerComponent, LoggerUtilsComponent } from '@proteo/core';

export class TokenService {
  constructor() {}

  /**
   * Get params
   * @param product product type
   * @returns response params
   */
  async getToken(): Promise<any> {
    try {
      const response = await DataManagerComponent.getInstance().post<any>('mobile-app/api-onboarding-bff/v0/token', null);
      return response.data.access_token;
    } catch (error) {
      LoggerUtilsComponent.getInstance().debug('[param.service] params error: ', error);
    }
  }
}
